"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _DqSpinner = _interopRequireDefault(require("../../feedback/DqSpinner/DqSpinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const DqButton = ({
  text,
  className,
  startIcon,
  endIcon,
  type = "button",
  color = "blue",
  size = "regular",
  variant = "solid",
  disabled = false,
  loading = false,
  href,
  to,
  onClick,
  ...otherProps
}) => {
  const commonClasses = "dq-inline-flex dq-items-center dq-justify-center dq-space-x-2 dq-min-w-32 dq-border-2 dq-border-transparent dq-rounded-md dq-transition-colors focus:dq-outline-none focus:dq-ring-2 focus:dq-ring-offset-2 focus:dq-ring-indigo-500";
  const colorClasses = {
    solid: {
      blue: "dq-bg-blue dq-text-white",
      orange: "dq-bg-orange dq-text-white",
      white: "dq-bg-white dq-text-gray-800",
      gray: "dq-bg-gray-800 dq-text-white dark:dq-bg-white dark:dq-text-gray-800",
      error: "dq-bg-red dq-text-white",
      warning: "dq-bg-orange-200 dq-text-white",
      info: "dq-bg-blue dq-text-white",
      success: "dq-bg-green dq-text-white"
    },
    outline: {
      blue: "dq-border-blue dq-text-blue",
      orange: "dq-border-orange dq-text-orange",
      white: "dq-border-white dq-text-white",
      gray: "dq-border-gray-800 dq-text-gray-800 dark:dq-border-white dark:dq-text-white",
      error: "dq-border-red dq-text-red",
      warning: "dq-border-orange-200 dq-text-orange-200",
      info: "dq-border-blue dq-text-blue",
      success: "dq-border-green dq-text-green"
    },
    text: {
      blue: "dq-text-blue",
      orange: "dq-text-orange",
      white: "dq-text-white",
      gray: "dq-text-gray-800 dark:dq-text-white",
      error: "dq-text-red",
      warning: "dq-text-orange-200",
      info: "dq-text-blue",
      success: "dq-text-green"
    }
  };
  const hoverClasses = {
    solid: {
      blue: "hover:dq-bg-blue-hover hover:dq-text-white",
      orange: "hover:dq-bg-orange-hover hover:dq-text-white",
      white: "hover:dq-bg-gray-50 hover:dq-text-gray-800",
      gray: "hover:dq-bg-gray-600 hover:dq-text-white",
      error: "hover:dq-bg-red-hover hover:dq-text-white",
      warning: "hover:dq-bg-orange-300 hover:dq-text-white",
      info: "hover:dq-bg-blue-hover hover:dq-text-white",
      success: "hover:dq-bg-green-hover hover:dq-text-white"
    },
    outline: {
      blue: "hover:dq-bg-blue hover:dq-text-white",
      orange: "hover:dq-bg-orange hover:dq-text-white",
      white: "hover:dq-bg-white hover:dq-text-gray-800",
      gray: "hover:dq-bg-gray-800 hover:dq-text-white",
      error: "hover:dq-bg-red hover:dq-text-white",
      warning: "hover:dq-bg-orange-200 hover:dq-text-white",
      info: "hover:dq-bg-blue hover:dq-text-white",
      success: "hover:dq-bg-green hover:dq-text-white"
    },
    text: {
      blue: "hover:dq-text-blue-hover",
      orange: "hover:dq-text-orange-hover",
      white: "hover:dq-text-blue-hover",
      gray: "hover:dq-text-gray-600",
      error: "hover:dq-text-red-hover",
      warning: "hover:dq-bg-orange-200 hover:dq-text-white",
      info: "hover:dq-text-blue-hover",
      success: "hover:dq-text-green-hover"
    }
  };
  const fontSizeClasses = {
    xsmall: "dq-text-sm",
    small: "dq-text-sm",
    regular: "dq-text-base",
    large: "dq-text-lg"
  };
  const sizeClasses = {
    xsmall: "dq-p-0",
    small: "dq-px-2.5 dq-py-1.5",
    regular: "dq-px-4 dq-py-2",
    large: "dq-px-6 dq-py-3"
  };
  const loadingSizeClasses = {
    xsmall: "dq-h-4 dq-w-4",
    small: "dq-h-5 dq-w-5",
    regular: "dq-h-6 dq-w-6",
    large: "dq-h-7 dq-w-7"
  };
  const disabledClasses = "dq-opacity-50 dq-cursor-not-allowed";
  const styleClasses = (0, _classnames.default)(commonClasses, colorClasses[variant][color], fontSizeClasses[size], variant === "text" ? "dq-p-0 !dq-border-0 !dq-min-w-0" : sizeClasses[size], disabled || loading ? disabledClasses : hoverClasses[variant][color], className);
  const buttonContent = loading ? /*#__PURE__*/_react.default.createElement(_DqSpinner.default, {
    className: loadingSizeClasses[size]
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, startIcon, text && /*#__PURE__*/_react.default.createElement("span", null, text), endIcon);
  if (href) return /*#__PURE__*/_react.default.createElement("a", _extends({}, otherProps, {
    href: href,
    className: styleClasses
  }), buttonContent);
  if (to) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({}, otherProps, {
    to: to,
    className: styleClasses
  }), buttonContent);
  return /*#__PURE__*/_react.default.createElement("button", _extends({}, otherProps, {
    type: type,
    disabled: disabled || loading,
    className: styleClasses,
    onClick: onClick
  }), buttonContent);
};

DqButton.defaultProps = {
  text: "",
  className: "",
  startIcon: null,
  endIcon: null,
  type: "button",
  color: "blue",
  size: "regular",
  variant: "solid",
  disabled: false,
  loading: false,
  href: "",
  to: "",
  onClick: () => {}
};
var _default = DqButton;
exports.default = _default;